<template>
  <v-row justify="end">
    <SnackBar ref="snackbar" />
    <v-dialog v-model="dialog" width="680">
      <template #activator="{ props }">
        <v-btn
          dark
          class="button-config"
          v-bind="props"
          style="background-color: #004984"
        >
          Cadastrar Sprint
          <v-icon right style="margin-left: 5px">mdi-account-plus</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ nomeProjetoTitulo }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <p>Início da Sprint</p>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <p>Fim da Sprint</p>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <VueDatePicker
                  v-model="dtInicio"
                  auto-apply
                  :min-date="new Date()"
                  :enable-time-picker="false"
                  :format="format"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <VueDatePicker
                  v-model="dtFim"
                  auto-apply
                  :min-date="dtInicio"
                  :enable-time-picker="false"
                  :format="format"
                ></VueDatePicker>
              </v-col>
            </v-row>
            <v-row v-if="repositorios.length > 0">
              <v-col cols="12">
                <v-label
                  >A sprint será criada no(s) seguinte(s)
                  repositório(s)</v-label
                >
                <v-container class="d-flex" v-if="isLoading">
                  <v-skeleton-loader
                    class="skeleton-wrapper"
                    type="list-item-two-line"
                    :loading="isLoading"
                    v-for="index in 3"
                    :key="index"
                  ></v-skeleton-loader>
                </v-container>
                <v-list
                  class="d-flex flex-wrap"
                  :min-width="150"
                  lines="one"
                  v-else
                >
                  <v-list-item
                    v-for="repositorio in repositorios"
                    :key="repositorio.tb_repositorio.id_repositorio"
                    :title="repositorio.tb_repositorio.nome"
                    :link="true"
                    @click="redirect(repositorio.tb_repositorio.url)"
                    :subtitle="`${repositorio.tb_repositorio.owner}`"
                    elevation="2"
                    class="repo-item"
                  ></v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" variant="text" @click="dialog = false">
            Cancelar
          </v-btn>
          <v-btn color="blue-darken-1" variant="text" @click="registerSprint">
            Cadastrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import axios from 'axios';
// import { ref } from 'vue';
import '@vuepic/vue-datepicker/dist/main.css';
import { ref } from 'vue';

import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: { VueDatePicker, SnackBar },
  props: {
    idProjeto: {
      type: Number,
      default: null,
    },
    nomeProjetoTitulo: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    dialog: false,
    dtInicio: new Date(),
    dtFim: new Date(),
    repositoriosSelecionados: [],
    listaRepositorios: [], // todos os repos da org
    listaRepositoriosAssoc: [], // repositórios já associados ao projeto
    repositorios: [], // todas as infos dos repos
    numeroRepositorios: 1,
    date: ref(new Date()),
    format: (date) => {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
  }),

  created() {
    this.fetchRepositorios();
  },
  methods: {
    registerSprint() {
      const data = {
        dtInicio: this.dtInicio.toISOString().replace(/\.\d{3}Z$/, ''),
        dtFim: this.dtFim.toISOString().replace(/\.\d{3}Z$/, ''),
        id_projeto: parseInt(this.idProjeto), // eslint-disable-line camelcase
      };
      const config = {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      axios
        .post(API_URL + '/sprints/', data, config)
        .then(() => {
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Sprint cadastrada com sucesso!',
          );
          this.dialog = false;
          this.dtInicio = new Date();
          this.dtFim = new Date();
          location.reload();
        })
        .catch((error) => {
          this.dtInicio = new Date();
          this.dtFim = new Date();
          console.log(error.response.data.error);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            `${error.response.data.error}`,
          );
        });
    },
    redirect(url) {
      window.open(url, '_blank');
    },
    fetchRepositorios() {
      axios
        .get(API_URL + `/projetos/${this.idProjeto}/repositorios`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          console.log(response.data);
          console.log(response.data.tb);
          this.repositorios = response.data;
          this.listaRepositoriosAssoc = this.repositorios.map(function (item) {
            return item.tb_repositorio.nome;
          });
        })
        .catch((error) => {
          console.log(error.response.data.error);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos buscar os repositórios!',
          );
        });

      axios
        .get(API_URL + `/projetos/${this.idProjeto}/org/repos`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          console.log(response.data);
          // selecionando os repositorios do projeto da lista de repositorios
          this.listaRepositorios = response.data.filter(
            (elemento) => !this.listaRepositoriosAssoc.includes(elemento),
          );
        })
        .catch((error) => {
          console.log(error.response.data.error);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos buscar os repositórios!',
          );
        });
    },
  },
};
</script>
<style scoped>
.repo-item {
  padding: 10px;
  margin: 10px 5px;
}
:deep(.dp__outer_menu_wrap) {
  position: fixed;
  z-index: 9999;
  top: 130px;
}
</style>
